import { GET } from "../../API/get";
import { FORMPOST, POST } from "../../API/post";
import { PUT } from "../../API/put";
import { getBackupJobDetails, getUserInfo, setBackupJobDetails } from "../../storage";
import { isValidUKPostcode } from "../../utils";

export const fetchPostcodeAddressList = async (inputValue, callback) => {
    try {
        if (isValidUKPostcode(inputValue)) {
            const response = await GET(`postcode/address/list/${inputValue}`);
            const addresses = response?.list;

            const options = addresses?.map((address) => ({
                value: address,
                label: `${address?.StreetAddress}, ${address?.Place}`,
            }));

            callback(options);
        } else {
            callback([]);
        }
    } catch (error) {
        callback([]);
    }
}

export const fetchAddressList = async (inputValue) => {
    const response = await GET(`postcode/address/list/${inputValue}`);
    return response.status === "Success" ? response : null;
};

export const fetchFtmLiveMap = async () => {
    const response = await GET(`customer/ftm/price-check-map`);
    return response.status === "Success" ? response : null;
}

export const fetchPostcodeAddressDetails = async (address) => {
    if (!address) return null;
    const response = await GET(`postcode/address/details/${address}`);
    return response?.status === "Success" ? response : null;
}

export const fetchSkillsWithSubSkills = async () => {
    const response = await GET("skills-with-subskills");
    return response.status === "Success" ? response : null;
}

export const fetchSettings = async () => {
    const response = await GET("customer/settings");
    return response.status === "Success" ? response : null;
}

export const fetchJobRatePreHour = async ({ sub_skill_id, eta_start_time, eta_end_time }) => {
    if (sub_skill_id !== undefined) {
        const response = await GET(`job/rate/pre/hour/${sub_skill_id}/${eta_start_time}/${eta_end_time}`);
        return response.status === "Success" ? response : null;
    } else {
        return null;
    }
}

export const findFtmInRetryJob = async ({ job_id, new_eta_start_time, new_eta_end_time }) => {
    const response = await PUT(`v2/find/ftm/retry/job`, {
        job_id,
        new_eta_start_time,
        new_eta_end_time
    });
    return response?.status === "Success" ? response : null;
}

export const fetchCheckIsHaveRunningJobs = async () => {
    const userInfo = getUserInfo();

    const response = await GET(`customer/check/is/have/running/jobs/${userInfo.customer_id}`);
    return response?.status === "Success" ? response : null;
};

export const createJob = async (data) => {
    const userInfo = getUserInfo();

    const {
        job_description,
        job_skill_id,
        job_latitude,
        job_longitude,
        job_address,
        job_postcode,
        job_eta_end_time,
        job_eta_start_time,
        job_note,
        cn_code
    } = data;

    const response = await POST("v2/create-jobs", {
        customer_id: userInfo.customer_id,
        job_skill_id: job_skill_id,
        job_description,
        job_latitude: job_latitude,
        job_longitude: job_longitude,
        job_address: job_address,
        job_postcode: job_postcode,
        job_eta_start_time: job_eta_start_time,
        job_eta_end_time: job_eta_end_time,
        job_platform: "WEB",
        job_note: job_note,
        cn_code: cn_code
    });

    return response?.status === "Success" ? response : null;
}

export const uploadImages = async (job_id, image) => {
    const image_response = await FORMPOST("upload-job-images", {
        job_id: job_id,
        job_image: image
    });

    return image_response;
}

export const customerHaveCard = async () => {
    const userInfo = getUserInfo();

    const response = await GET(`customer/have/card/${userInfo.customer_id}`);
    return response?.status === "Success" ? response : null;
}

export const fetchFindFtm = async (job_id) => {
    const response = await GET(`v2/find-ftm/${job_id}`);
    return response?.status === "Success" ? response : null;
}

export const fetchPriceCheckDetails = async (type) => {
    const response = await GET(`price/check/details/${type}`);
    return response?.status === "Success" ? response : null;
}

export const fetchPriceCheckAllDetails = async () => {
    const response = await GET(`price/check/all/details`);
    return response?.status === "Success" ? response : null;
}

export const fetchJobNeedTimeDescription = async (sub_skill_id) => {
    const response = await GET(`job-need/time-description/${sub_skill_id}`);
    return response?.status === "Success" ? response : null;
}

export const fetchPricingRule = async ({ subSkillId, startTime, endTime }) => {
    const response = await GET(`pricing/rules/${startTime}/${endTime}?sub_skill_id=${subSkillId}`);
    return response?.status === "Success" ? response : null;
};

export const fetchPriceCheckSettings = async () => {
    const response = await GET(`price/check/settings`);
    return response?.status === "Success" ? response : null;
};

export const updateStoredJobDetails = async (key, value) => {
    const savedJob = await getBackupJobDetails();

    await setBackupJobDetails({
        ...savedJob,
        [key]: value
    });
};

export const fetchDescriptionAssets = async (job_id) => {
    const response = await GET(`v3/jobs/${job_id}/description-assets`);
    return response?.status === "Success" ? response : null;
};

export const fetchBookAgainDetails = async (job_id) => {
    const response = await GET(`v3/jobs/${job_id}/book-again`);
    return response?.status === "Success" ? response : null;
};